import I18n from '../../../../lib/i18n';

const REGION_POSTCODE_REGEX = {
  BLM: /^97133$/,
  MAF: /^97149|97150$/,
  MTQ: /^972\d{2}/,
  GUF: /^973\d{2}/,
  GLP: /^97(?!133|149|150)\d{3}$/,
};

export const getStateOrProvinceFromPostCode = (postCode: string): string => {
  if (!postCode) {
    return '';
  }

  for (const trigram in REGION_POSTCODE_REGEX) {
    if (REGION_POSTCODE_REGEX[trigram].test(postCode)) {
      return I18n.t(`SignUp.ChooseRegion.regionName.${trigram}`);
    }
  }

  return '';
};

export const getTrigramFromPostCode = (postCode: string): string => {
  if (!postCode) {
    return '';
  }

  const trigram = Object.entries(REGION_POSTCODE_REGEX).find(objectEntries => objectEntries[1].test(postCode));

  return trigram ? trigram[0] : '';
};
